export const iconFontAwesomeSciencefictionRobot = (
	<i className="fa-solid fa-robot"></i>
);
